import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  signal,
} from '@angular/core';
import { ActionCardIconComponent } from '../../atoms/cards/action-card/action-card-icon.component';

@Component({
  selector: 'ui-device-alarm-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ActionCardIconComponent],
  template: `
    <div
      class="flex flex-wrap items-center justify-between gap-x-6 w-full h-full bg-white shadow-md p-6 rounded-lg"
    >
      <div class="flex flex-col">
        <span class="text-3xl" [class]="countClass()">
          {{ count() ?? '--' }}
        </span>
        <span class="text-neutral-8">
          {{ label() }}
        </span>
      </div>
      <ui-action-card-icon icon [icon]="icon()" class="{{ iconClass() }}" />
    </div>
  `,
})
export class DeviceAlarmCard {
  label = input<string>();
  count = input<number | null>();
  class = signal<string>('');
  icon = input<string>();
  countClass = computed(() =>
    (this.count() ?? 0) > 0 ? 'text-error' : 'text-neutral-7',
  );
  iconClass = computed(() =>
    (this.count() ?? 0) > 0
      ? 'text-error bg-red-1 shadow-custom-red'
      : 'text-neutral-7 bg-neutral-2 shadow-custom-neutral-6',
  );
}
